<ion-list-header>{{ 'Choose File Format' | translate }}</ion-list-header>
<ion-list>
  <ion-item (click)="dismissPopover('PDF');"button>PDF</ion-item>
  <ion-item (click)="dismissPopover('PPTX');"button>PPTX</ion-item>
  <!-- <ion-item (click)="dismissPopover('PNG');"button>PNG</ion-item> -->
  <!-- Getting 403 Forbidden error from PowerBI when trying to export as PNG, which indicates that "Export report to image is disabled on tenant level". -->
</ion-list>

